var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('portal-base-button',{class:{ 'is-favorite': _vm.isFavorite },attrs:{"type":"favorite"},on:{"click":_vm.action}},[_vm._v(_vm._s(_vm.favoriteTitle))])}
var staticRenderFns = []

export { render, staticRenderFns }